import Home from "./components/home";
import Offer from "./components/offer";
import Privacy from "./components/privacy-policy";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import ProgrammPage from "./components/programm";
import Сongratulation from "./components/congratulations";

function App() {
  return (
    <div className="App">
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                {<Route path="/programm" element={<ProgrammPage />} />}
                <Route path="/offer" element={<Offer />} />
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/congratulations" element={<Сongratulation />} />
            </Routes>
        </BrowserRouter>
    </div>
  );
}

export default App;
